export default __webpack_public_path__ + "static/media/head-eagle.3579fb47.png";